import { isEqual, pick } from './objectHelpers';

// Types

import { Address } from '@components/ssap/SsapTypes';

export const checkIfTrueObject = (value: any): boolean => typeof value === 'object' &&
    !Array.isArray(value) &&
    value !== null;

export const checkIfAddressesEqual = (
    address1: Address | any,
    address2: Address | any,
    additionalKeysToCompare: Array<string> = []
) => {

    if (!checkIfTrueObject(address1) || !checkIfTrueObject(address2)) {
        return false;
    }

    if(!Array.isArray(additionalKeysToCompare)) {
        return false;
    }

    const keysToCompare: Array<string> = [
        'city',
        'countyCode',
        'postalCode',
        'state',
        'streetAddress1',
        'streetAddress2',
        ...additionalKeysToCompare
    ];

    const prepareValues = (address: Address) => {
        const adjustToNull = (entry: object): object => {
            const [ [ key, value ] ] = Object.entries(entry);

            if (!value) {
                return { [ key ]: null };
            }

            return entry;
        };

        return {
            ...pick(address, keysToCompare),
            ...adjustToNull({ streetAddress2: address.streetAddress2 })
        };
    };

    const address1ComparedValues = prepareValues(address1);
    const address2ComparedValues = prepareValues(address2);

    return isEqual(address1ComparedValues, address2ComparedValues);
};